import {
  TextField,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Stack,
} from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useState } from "react"
import { DateTimePicker } from "../ui/DateTimePickers"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"
import SetQuestionsModal from "./SetQuestionsModal"

const AddQuizModal = (props) => {
  const [questionsModal, setQuestionsModal] = useState(false)
  const openQuestions = () => setQuestionsModal(true)
  const closeQuestions = () => setQuestionsModal(false)
  return (
    <>
      <Modal
        {...props}
        title="Add Quiz"
        actionText="Set Questions"
        action={openQuestions}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <FormItem label="Quiz name">
            <TextField />
          </FormItem>
          <FormItem label="Select batches">
            <FormGroup row>
              <FormControlLabel control={<Checkbox />} label="Batch 1" />
              <FormControlLabel control={<Checkbox />} label="Batch 2" />
            </FormGroup>
          </FormItem>

          <Stack direction="row" spacing={3} alignItems="center">
            <FormItem label="Quiz start time">
              <DateTimePicker />
            </FormItem>
            <FormItem label="Quiz end time">
              <DateTimePicker />
            </FormItem>
          </Stack>
        </LocalizationProvider>
      </Modal>
      <SetQuestionsModal isOpen={questionsModal} close={closeQuestions} />
    </>
  )
}

export default AddQuizModal
